import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Button from '@nexus/fff-ui-shared/Button';

import { shopAllAction } from './actions';

const ShopAllButton = ({ resetSearch, selectedCategoryId }) => {
  const history = useHistory();
  return (
    <Button
      variation="primary"
      onClick={() => shopAllAction(history, selectedCategoryId, resetSearch)}
    >
      Shop All
    </Button>
  );
};

ShopAllButton.propTypes = {
  resetSearch: PropTypes.func.isRequired,
  selectedCategoryId: PropTypes.string,
};

ShopAllButton.defaultProps = {
  selectedCategoryId: null,
};

export default ShopAllButton;
